import {i18n} from '@/plugins/i18n';

export default [
    {
        field: 'traceId',
        title: i18n.t('label.track_code'),
        sortable: false,
        type: 'string',
        textAlign: 'center',
    },
    {
        field: 'receiverName',
        title: i18n.t('label.receiver_name'),
        sortable: false,
        type: 'string',
        template: row => {
            return '<div>' + String(row.receiverName).slice(0, 15) + '</div>';
        },
        textAlign: 'center',
    },
    {
        field: 'amount',
        title: i18n.t('label.amount'),
        sortable: false,
        type: 'string',
        textAlign: 'center',
    },
    {
        field: 'comment',
        title: i18n.t('label.title'),
        sortable: false,
        type: 'string',
        textAlign: 'center',
    },
    {
        field: 'transactionDate',
        title: i18n.t('label.date'),
        sortable: false,
        type: 'string',
        textAlign: 'center',
    },
    {
        field: 'payaCycle',
        title: i18n.t('label.paya_cycle'),
        sortable: false,
        type: 'string',
        textAlign: 'center',
    },
]
